var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 57",
    width: 180,
    height: 57,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "playStore-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t\t.s1 { fill: #010202 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m28.8 0.4h122.4c15.4 0 27.9 12.5 27.9 28 0 15.5-12.5 28-27.9 28h-122.4c-15.4 0-27.9-12.5-27.9-28 0-15.5 12.5-28 27.9-28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m76.2 42.2l-0.9-2.4h-6.1l-0.9 2.4h-2.3l5.9-14.2h0.7l5.9 14.2zm-1.7-4.3l-2.2-5.8-2.3 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m89.1 33.1q1.3 1.6 1.3 3.9 0 2.3-1.3 3.9c-1 1-2.1 1.5-3.6 1.5-1.4 0-2.5-0.5-3.3-1.5v5.1h-2.1v-14.2h2v1.5c0.7-1.1 2-1.7 3.4-1.7 1.5 0 2.6 0.5 3.6 1.5zm-1.7 6.3c0.6-0.6 0.8-1.4 0.8-2.4q0-1.5-0.8-2.5-0.9-0.9-2.2-0.9c-1.7 0-3 1.1-3 3.3 0 1.2 0.3 2 0.8 2.6 0.6 0.6 1.4 0.8 2.2 0.8q1.3 0 2.2-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m101.4 33.1q1.4 1.6 1.4 3.9 0 2.3-1.4 3.9c-0.9 1-2.1 1.5-3.5 1.5-1.4 0-2.6-0.5-3.3-1.5v5.1h-2.2v-14.2h2v1.5c0.8-1.1 2-1.7 3.5-1.7 1.4 0 2.6 0.5 3.5 1.5zm-1.6 6.3c0.6-0.6 0.8-1.4 0.8-2.4q0-1.5-0.8-2.5-0.9-0.9-2.2-0.9c-1.7 0-3 1.1-3 3.3 0 1.2 0.2 2 0.8 2.6 0.6 0.6 1.4 0.8 2.2 0.8 0.8 0 1.5-0.3 2.2-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m114.3 28q-1.8 0-3 1-1.2 1.1-1.2 2.8c0 1.8 1.1 2.9 3.1 3.9l1.4 0.7c1.4 0.7 2 1.1 2 2.1 0 1.2-0.9 1.9-2.3 1.9-1.4 0-2.5-0.7-3.6-2.2l-1.5 1.2c1.1 1.9 2.9 3 5.1 3 1.3 0 2.4-0.4 3.2-1.1 0.9-0.7 1.3-1.7 1.3-2.9 0-1.8-1.1-2.9-3.2-4l-1.5-0.7c-1.4-0.7-1.9-1.1-1.9-2 0-1.1 0.9-1.7 2-1.7 1.2 0 2.1 0.6 2.8 1.7l1.5-1.2c-0.7-1.5-2.3-2.5-4.2-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m125.5 40.4c-1.3 0-1.9-0.5-1.9-1.8v-4.9h2.9v-1.9h-2.9v-2.8h-2.2v2.8h-1.6v1.9h1.6v5.1c0 2.4 1.4 3.6 3.7 3.6q0.7-0.1 1.7-0.3v-1.8c-0.6 0-1 0.1-1.3 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m136.7 33.1c1 1 1.6 2.3 1.6 3.8 0 1.6-0.5 2.9-1.6 3.9-1 1-2.3 1.6-3.7 1.6-1.5-0.1-2.7-0.6-3.7-1.6-1.1-1-1.6-2.4-1.6-3.9q0-2.2 1.6-3.8c1-1 2.2-1.5 3.7-1.5 1.4 0 2.7 0.5 3.7 1.5zm-5.9 1.5c-0.5 0.6-0.8 1.5-0.8 2.4 0 1 0.3 1.8 0.8 2.4q0.9 1 2.2 1 1.3 0 2.2-1c0.6-0.6 0.9-1.4 0.9-2.4 0-1-0.3-1.8-0.9-2.4q-0.9-1-2.2-1-1.3 0-2.2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m145.2 31.7c-1.2 0-2.2 0.5-2.9 1.4v-1.3h-2v10.3h2.1v-5.5c0-1.8 1.3-2.9 2.9-2.9h0.7v-1.9c-0.2-0.1-0.5-0.1-0.8-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m156.3 37.7h-7.4c0.3 1.7 1.5 2.7 3.2 2.7q1.6 0 2.9-1.2l1 1.5q-1.7 1.7-3.9 1.7-2.3 0-3.8-1.6-1.6-1.6-1.6-3.9c0-1.5 0.5-2.7 1.5-3.8 1-1 2.2-1.6 3.7-1.6q1.9 0 3.2 1.4 1.3 1.3 1.4 3.4c0 0.4-0.1 0.9-0.2 1.4zm-7.4-1.7h5.4c0-1.6-1.1-2.6-2.5-2.6-1.5 0-2.6 1-2.9 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m68.7 15q-1.6 0-2.6 1-1.1 1.1-1.1 2.7 0 1.6 1.1 2.7 1 1 2.6 1c1.4 0 2.6-0.7 3.2-1.9v-2h-3.3v1h2.2v0.8c-0.5 0.8-1.2 1.1-2.1 1.1q-1.2 0-1.9-0.7c-0.5-0.6-0.7-1.2-0.7-2 0-0.8 0.2-1.4 0.7-1.9q0.7-0.8 1.8-0.8 1.4 0 2.1 1.2l0.8-0.7c-0.6-1-1.6-1.5-2.8-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m73.3 15.1v7.3h4.7v-1.1h-3.6v-2.3h2.7v-1h-2.7v-1.9h3.5v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.6 15.1v1h2.4v6.3h1.1v-6.3h2.3v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m87.9 15.1h1.1v7.3h-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m90.1 15.1v1h2.3v6.3h1.1v-6.3h2.4v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m105.2 16q1 1.1 1 2.7 0 1.6-1 2.7-1.1 1-2.6 1c-1.1 0-1.9-0.3-2.6-1q-1.1-1.1-1.1-2.7 0-1.6 1.1-2.7 1.1-1 2.6-1c1 0 1.9 0.3 2.6 1zm-4.4 0.8c-0.5 0.5-0.7 1.1-0.7 1.9q0 1.1 0.7 1.9c0.5 0.5 1.1 0.8 1.8 0.8q1 0 1.8-0.8 0.7-0.7 0.7-1.9c0-0.8-0.2-1.4-0.7-1.9-0.5-0.5-1.1-0.8-1.8-0.8q-1.1 0-1.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m112.2 20l-4.2-5h-0.4v7.4h1.1v-4.9l4.3 5h0.4v-7.4h-1.1v4.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.2 29.7c-0.1-4.2 3.7-6.3 3.8-6.4-2.1-2.8-5.4-3.2-6.5-3.3-2.7-0.3-5.4 1.6-6.8 1.6-1.4 0-3.6-1.5-5.9-1.5-3 0.1-5.8 1.7-7.3 4.2-3.2 5.1-0.8 12.7 2.2 16.8 1.6 2 3.3 4.3 5.6 4.2 2.3-0.1 3.2-1.3 5.9-1.3 2.7 0 3.5 1.3 5.9 1.3 2.4-0.1 4-2.1 5.4-4.1 1.8-2.3 2.5-4.6 2.5-4.7-0.1-0.1-4.8-1.7-4.8-6.8zm-4.5-12.3c1.2-1.5 2-3.4 1.8-5.4-1.7 0-4 1.1-5.2 2.5-1.2 1.2-2.2 3.3-1.9 5.2 2 0.1 4-1 5.3-2.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/appleStore.b93b3208ac2a7ecec50a4d6f46d4a43d.svg";
export { ForwardRef as ReactComponent };